export enum ContractorInvoiceFilters {
  from = 'filters[invoice][created_at][from]',
  to = 'filters[invoice][created_at][to]',
  status = 'filters[invoice][status][]',
}

export enum ContractorArchivedInvoiceFilters {
  from = 'filters[archived_invoice][date_created][from]',
  to = 'filters[archived_invoice][date_created][to]',
}

export enum ContractorInvoiceSort {
  issueDate = 'sort[invoice][created_at]',
  invoiceNumber = 'sort[invoice][number]',
  paymentMethod = 'sort[invoice][payment_method]',
  total = 'sort[invoice][total]',
  status = 'sort[invoice][status]',
}

export enum ContractorArchivedInvoiceSort {
  issueDate = 'sort[archived_invoice][date_created]',
  invoiceNumber = 'sort[archived_invoice][number]',
  paymentMethod = 'sort[archived_invoice][payment_method]',
  total = 'sort[archived_invoice][total_to_pay]',
  campaignName = 'sort[archived_invoice][campaign_name]',
}

export enum ManagerArchivedInvoiceFilters {
  from = 'filters[archived_invoice][date_created][from]',
  to = 'filters[archived_invoice][date_created][to]',
  status = 'filters[archived_invoice][status]',
  statusArray = 'filters[archived_invoice][status][]',
  contractor = 'filters[contractor][id]',
  contractorIdArray = 'filters[contractor][id][]',
  search = 'search',
}

export enum ManagerInvoiceFilters {
  from = 'filters[invoice][created_at][from]',
  to = 'filters[invoice][created_at][to]',
  status = 'filters[invoice][status]',
  statusArray = 'filters[invoice][status][]',
  contractor = 'filters[contractor][id]',
  contractorIdArray = 'filters[contractor][id][]',
  paymentFrequency = 'filters[contractor][payment_frequency][]',
  search = 'search',
}

export enum ManagerInvoicesSort {
  companyName = 'sort[contractor][company_name]',
  createdAt = 'sort[invoice][created_at]',
  itemsCount = 'sort[invoice][items_count]',
  number = 'sort[invoice][number]',
  paymentMethod = 'sort[invoice][payment_method]',
  paymentFrequency = 'sort[contractor][payment_frequency]',
  status = 'sort[invoice][status]',
  total = 'sort[invoice][total]',
}

export enum ManagerArchivedInvoicesSort {
  companyName = 'sort[contractor][company_name]',
  campaignName = 'sort[archived_invoice][campaign_name]',
  createdAt = 'sort[archived_invoice][date_created]',
  itemsCount = 'sort[archived_invoice][total_items_to_pay]',
  number = 'sort[archived_invoice][number]',
  status = 'sort[archived_invoice][status]',
  total = 'sort[archived_invoice][total_to_pay]',
}
